import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import StickyMobileCTA from "@/components/StickyMobileCTA";
import StickyBrochureCTA from "@/components/StickyBrochureCTA";
import ChatbotMascot from "@/components/ChatbotMascot";
import { ScrollPopup, ExitIntentPopup } from "@/components/Popups";
import { Toaster } from "sonner";
import { pageView } from "@/lib/analytics";

export default function Layout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
    // Never track admin pages — those are internal.
    if (!pathname.startsWith("/admin")) {
      pageView(pathname);
    }
  }, [pathname]);

  const onEOI = pathname.startsWith("/eoi");
  const onReserve = pathname.startsWith("/reserve");
  const onAdmin = pathname.startsWith("/admin");
  // Peat + sticky CTAs + popups are muted on the two conversion pages
  // (/eoi Meta-ads landing, /event registration, /reserve refundable EOI)
  // because the flow there is task-focused and popups/chat compete with
  // the primary CTA.
  const onEvent = pathname.startsWith("/event");
  const suppressChrome = onEOI || onReserve;

  return (
    <div className="App">
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
      {!suppressChrome && !onAdmin && <StickyMobileCTA />}
      {!onAdmin && !onEvent && !suppressChrome && <ChatbotMascot />}
      {!onAdmin && !suppressChrome && <StickyBrochureCTA />}
      <ScrollPopup />
      <ExitIntentPopup />
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#0B4A3D",
            color: "#F4F4EF",
            border: "1px solid rgba(166,206,57,0.4)",
          },
        }}
      />
    </div>
  );
}
